import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth = cookie httpOnly `lel_session` (posé par le backend au login).
// withCredentials envoie automatiquement le cookie sur chaque requête cross-origin.
// Plus aucun token n'est stocké en JavaScript — mitigation XSS complète.
export const api = axios.create({ baseURL: API, withCredentials: true });
